export class HorsPta {
  libelle: any;
  date_realisation: any;
  montant: any;
  service_id: any;
  observations: any;
  reference: any;
  annee: any;

  private errorMessage: string;

  constructor() {
    this.errorMessage = "";
  }

  getErrorMessage(): string {
    return this.errorMessage;
  }

  canSave(): boolean {

    if (!this.libelle || this.libelle.trim() === "") {
      this.errorMessage = "Veuillez saisir le libellé";
      return false;
    }

    if (!this.date_realisation) {
      this.errorMessage = "Veuillez saisir la date de réalisation";
      return false;
    }

    if (!this.montant || this.montant <= 0) {
      this.errorMessage = "Veuillez saisir un montant valide";
      return false;
    }

    if (!this.service_id) {
      this.errorMessage = "Veuillez sélectionner un service";
      return false;
    }

   /*  if (!this.reference || this.reference.trim() === "") {
      this.errorMessage = "Veuillez saisir la référence";
      return false;
    } */

    // if (!this.annee) {
    //   this.errorMessage = "Veuillez saisir l'année";
    //   return false;
    // }

    // Optionnel
    // if (!this.observations || this.observations.trim() === "") {
    //   this.errorMessage = "Veuillez saisir une observation";
    //   return false;
    // }

    this.errorMessage = "";
    return true;
  }
}